import $ from 'gridstrap/lib/gs-zepto';

export class GSProductPicks {
	private root;

	constructor(root) {
		this.root = $(root);
	}
}
